import styled from 'styled-components';
import { Colors } from '@prezi/dragon';

export default styled.div<{ size: number }>`
    color: ${Colors.neutral600};
    font-size: ${p => p.size}px;
    line-height: ${p => Math.floor(p.size * 1.15)}px;
`;
